<template>
  <div class="login">
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
      <!-- <h3 class="title">{{title}}</h3> -->
      <el-form-item prop="username">
        <el-input v-model="loginForm.username" type="text" auto-complete="off" placeholder="账号">
          <svg-icon slot="prefix" icon-class="user" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" type="password" auto-complete="off" placeholder="密码"
          @keyup.enter.native="handleLogin">
          <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
        </el-input>
      </el-form-item>

      <el-checkbox v-model="loginForm.rememberMe" style="margin:0px 0px 25px 0px;">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button :loading="loading" size="medium" type="primary" style="width:100%;"
          @click.native.prevent="handleLogin">
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
      </el-form-item>
    </el-form>
    <!--  底部  -->
    <!-- <div class="el-login-footer">
        <span>Copyright © 2020 苏州市华信信息技术有限公司 苏ICP备12034962号-1</span>
      </div> -->
  </div>
</template>
  
<script>
import { getParkRsLoginTo } from "@/api/coupon/admin";
import Cookies from "js-cookie";
import { encrypt, decrypt } from '@/utils/jsencrypt'

export default {
  name: "Login",
  data() {
    return {
      //   title: "后台管理系统",
      codeUrl: "",
      cookiePassword: "",
      loginForm: {
        username: "",
        password: undefined,
        rememberMe: false,
        // code: "",
        // uuid: ""

      },
      rememberMe:"",
      loginRules: {
        username: [
          { required: true, trigger: "blur", message: "用户名不能为空" }
        ],
        password: [
          { required: true, trigger: "blur", message: "密码不能为空" }
        ],
        code: [{ required: true, trigger: "change", message: "验证码不能为空" }]
      },
      loading: false,
      redirect: undefined
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created() {
    this.rememberMe = Cookies.get('rememberMe')
    this.loginForm.rememberMe =Boolean(Cookies.get('rememberMe')) 
    console.log(this.loginForm.rememberMe,'this.loginForm.rememberMe');
 
    // return
    if (this.rememberMe=='true') {
      this.loginForm.password = Cookies.get('password')
      this.loginForm.username = Cookies.get('username')
     
      // this.$router.push({ name: "parkingLot", });
    } else{
      this.$weui.alert('登录过期，请重新登录')
    }
    



  },
  methods: {
   
    handleLogin() {
  

      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true;
      
          getParkRsLoginTo(this.loginForm).then((res) => {
           

            console.log(res, 'res');
            this.loading = false;

            if (res.code == 200) {
              if (this.loginForm.rememberMe) {
                Cookies.set("Token", res.token, { expires: 30 });
                Cookies.set('rememberMe', this.loginForm.rememberMe, { expires: 30 });
                Cookies.set('password', this.loginForm.password, { expires: 30 });
                Cookies.set('username', this.loginForm.username, { expires: 30 });
              }else{
                Cookies.set("Token", res.token, );
               
                
              }
              
              this.$router.push({ name: "parkingLot", });
            }

       
          }).catch(() => {
            this.loading = false;
           
          });
        }
      });
    }
  }
};
</script>
  
<style  lang="stylus">
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    // background-image: url("../assets/image/login-background.jpg");
    background-size: cover;
  }
  .title {
    margin: 0px auto 30px auto;
    text-align: center;
    color: #707070;
  }
  
  .login-form {
    border-radius: 6px;
    background: #ffffff;
    width: 400px;
    padding: 25px 25px 5px 25px;
    .el-input {
      height: 38px;
      input {
        height: 38px;
      }
    }
    .input-icon {
      height: 39px;
      width: 14px;
      margin-left: 2px;
    }
  }
  .login-tip {
    font-size: 13px;
    text-align: center;
    color: #bfbfbf;
  }
  .login-code {
    width: 33%;
    height: 38px;
    float: right;
    img {
      cursor: pointer;
      vertical-align: middle;
    }
  }
  .el-login-footer {
    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center;
    color: #fff;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;
  }
  </style>
  